import React from "react";
import "../programs/Programs.css";
import { useRef } from "react";
import { useEffect, useState } from "react";
import "./CompanyTherapistsList.css";
import axios from "axios";
import Select from "../select/Select";

const CompanyTherapistsList = (props) => {
  const userBusinessID =
    localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).business_id
      : -1;
  const wrapperTherapistRef = useRef("");
  useOutsideDotClose(wrapperTherapistRef);
  function useOutsideDotClose(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          const data = [...props.membersData];
          for (let m of data) {
            m.modalOpened = false;
          }
          props.updateMemberData(data);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
      // eslint-disable-next-line
    }, [ref, props]);
  }

  // eslint-disable-next-line
  const [isCompanyAdmin, setIsCompanyAdmin] = useState(null);
  const [succPopUp, setSuccPopUp] = useState("");
  const [organizationList] = useState([
    { key: 1, value: "Yes" },
    { key: "0", value: "No" },
  ]);

  const handleCompanyAdmin = (callVal, value, email) => {
    if (value) {
      value = parseInt(value);
      setIsCompanyAdmin(value);

      var userData = JSON.parse(localStorage.getItem("userData"));
      if (userData === null) {
        props.checkLoggedIn(false);
      } else {
        axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
        axios
          .post(window.ajaxLink + "cloud_therapist/update-new-therapist", { email, value })
          .then((res) => {
            if (res.data.responseData) {
              setSuccPopUp("Company Admin has been successfully updated.");
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  };

  const popupRef = useRef(succPopUp);
  useEffect(() => {
    popupRef.current = succPopUp;
    const timeout = setTimeout(() => {
      setSuccPopUp(false);
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [succPopUp]);

  return (
    <div className="table_component_main_container">
      <div className="programs_top_hold">
        {/* <div className="settings_input_hold"> */}
          <input
            type="text"
            ref={props.search}
            placeholder={"Search"}
            className="programs_search_bar"
            onChange={() => props.updateSearchQuery(props.search.current.value)}
          />
          {/* <div className="dash_box_search_icon sett_box_search_icon"></div> */}
        {/* </div> */}
        <div className="top_hold_buttons">
          <div className="programs_menu"></div>
        </div>
      </div>

      

      <div className="table_scrollable_container_new">
        <div className="table_scrollable_inner_container">
      {props.membersData.length > 0 ? (
        <div className="programs_table">
          <div className="programs_cols">
            <div className="programs_col_info">
              <div className="programs_col_name">First Name</div>
              <div
                className="programs_col_icon pt_col_icon"
                onClick={() => props.handleSorting("firstName", props.membersData)}
              ></div>
            </div>
            <div className="programs_col_info">
              <div className="programs_col_name">Last Name</div>
              <div
                className="programs_col_icon pt_col_icon"
                onClick={() => props.handleSorting("lastName", props.membersData)}
              ></div>
            </div>
            {userBusinessID <= 0 && (
              <div className="programs_col_info">
                <div className="programs_col_name">Company Name</div>
                <div
                  className="programs_col_icon"
                  onClick={() => props.handleSorting("company", props.membersData)}
                ></div>
              </div>
            )}
            <div className="programs_col_info">
              <div className="programs_col_name">Role</div>
              <div className="programs_col_icon" onClick={() => props.handleSorting("role", props.membersData)}></div>
            </div>
            <div className="programs_col_info">
              <div className="programs_col_name">Email</div>
              <div className="programs_col_icon" onClick={() => props.handleSorting("email", props.membersData)}></div>
            </div>
            <div className="programs_col_info">
              <div className="programs_col_name">Company Admin</div>
              <div
                className="programs_col_icon"
                onClick={() => props.handleSorting("companyAdmin", props.membersData)}
              ></div>
            </div>
            <div className="programs_tbl_col_last" style={{ height: 0 }}></div>
          </div>
        </div>
      ) : props.contentLoadedTherapist ? (
        <div className="programs_table_no_content">
          <div className="no_content_notice_contain">
            <div className="programs_no_results_img"></div>
            <div className="programs_no_res_main">You have no Therapists</div>
          </div>
        </div>
      ) : (
        <div className="programs_table_no_content">
        <div className="no_content_notice_contain">
        <div className="p_load"></div>
      </div>
      </div>
      )}
      {props.membersData.length > 0 && (
        
        <div className="tbl_content_hold">
          {props.membersData &&
            props.membersData.map((item, i) => (
              <div key={i} className="programs_tbl_content current_patient_mark">
                <div className="programs_tbl_row client-list_row">
                  <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col">{item.firstName}</div>
                  </div>
                  <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col">{item.lastName}</div>
                  </div>
                  {userBusinessID <= 0 && (
                    <div className="programs_tbl_col_contain">
                      <div className="programs_tbl_col">{item.company}</div>
                    </div>
                  )}
                  <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col">{item.role}</div>
                  </div>

                  <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col">{item.email}</div>
                  </div>
                  <div className="programs_tbl_col_contain">
                    {/* <div className="programs_tbl_col">{item.companyAdmin}</div> */}
                    <Select
                      selectOptions={organizationList}
                      initVal={item.companyAdmin}
                      selectCallback={function (callVal, value) {
                        handleCompanyAdmin(callVal, value, item.email);
                      }}
                      callBackValue={setIsCompanyAdmin}
                      inSettings={true}
                    ></Select>
                  </div>
                  {!item.modalOpened ? (
                    <div
                      className="programs_tbl_col programs_tbl_col_last list-options h-full"
                      style={{ userSelect: "none" }}
                      onClick={() => props.modalOpened(i)}
                    >
                      ...
                    </div>
                  ) : (
                    <div
                      className="programs_tbl_col programs_tbl_col_last list-options"
                      style={{ height: 0, pointerEvents: "none" }}
                      onClick={() => props.modalOpened(i)}
                    >
                      ...
                    </div>
                  )}
                  {item.modalOpened && !item.isRegistered && (
                    <div
                      className={
                        i === props.membersData.length - 1
                          ? "workouts-list__container_last therapist-list__container therapist-list__container_last"
                          : "client-list__container hexercise-list__container"
                      }
                      ref={wrapperTherapistRef}
                    >
                      <div onClick={() => props.handleResendModal(item.memberId)}>Resend Invitation</div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          {props.modalVisible && (
            <div className="dlt_wrapper" style={{ position: "fixed" }}>
              <div className="dbl_place_on_page">
                <div className="dlt_surround ">
                  <div className="dlt_title">Resend Invitation</div>
                  <div className="dlt_description">
                    <p>Do you want to resend Therapist invitation?</p>
                  </div>
                  <div className="dlt_exit_btm">
                    <div className="dlt_exit_btn dlt_eb_first" onClick={props.closeResendModal}>
                      Cancel
                    </div>
                    <div className="dlt_exit_btn dlt_eb_scnd" onClick={() => props.handleResendInvitation()}>
                      Send
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      </div>
      </div>
      {succPopUp && (
        <div className="prog_err_hold prog_pop_pat_correct">
          <div className="prog_pop_icon_correct prog_err_icon"></div>
          <div className="prog_err_text prog_pop_text_correct">{succPopUp}</div>
        </div>
      )}
    </div>
  );
};

export default CompanyTherapistsList;
